var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { attrs: { id: _vm.sectionname } }, [
    _c(
      "div",
      {
        class: _vm.isOpen
          ? "section-header section-opened"
          : "section-header section-closed",
      },
      [
        _c("h4", { staticClass: "subtitle" }, [
          _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _c("span", { staticClass: "checkout-section" }, [
                _vm._v(_vm._s(_vm.sectionindex)),
              ]),
              _vm._v(" "),
              _vm._t("title"),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm.isOpen ? _vm._t("action-open") : _vm._e(),
              _vm._v(" "),
              !_vm.isOpen ? _vm._t("action-closed") : _vm._e(),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-action-wrapper" },
          [
            _vm.isOpen ? _vm._t("action-open") : _vm._e(),
            _vm._v(" "),
            !_vm.isOpen ? _vm._t("action-closed") : _vm._e(),
          ],
          2
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "sectionBody",
        staticClass: "section-body",
        class: { open: _vm.isOpen },
      },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }